import { CheckBox } from '../CheckBox';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";
const styledContainer = {
  width: '20px',
  height: '20px',
  display: 'flex'
};
export const RowSelectCell = _ref => {
  let {
    onChange,
    checked,
    index,
    onChangeNative,
    disabled
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    sx: styledContainer,
    className: 'ids-row-select-cell',
    children: /*#__PURE__*/_jsx(CheckBox, {
      value: index.toString(10),
      onChange: onChange,
      checked: checked,
      onChangeNative: onChangeNative,
      disabled: disabled
    })
  });
};